// extracted by mini-css-extract-plugin
export default {"transitionContainer":"TransitionBlock_transitionContainer__+JoBV","transitionBlock":"TransitionBlock_transitionBlock__eSlc6"};